import React, { useEffect, useState } from "react";
import {
  ConfirmationModal,
  CustomTable,
  DeleteButton,
  MessageBox,
  MotionDiv,
  useTitle,
  ViewButton,
} from "../../components";
import { useDeleteUserMutation, useGetAllUsersQuery, useToggleActivationMutation } from "../../store";
import { useNavigate } from "react-router-dom";
import { ImCross } from "react-icons/im";
import {
  FaCheck,
  FaCheckCircle,
  FaCheckSquare,
  FaCircle,
  FaSquare,
  FaTimesCircle,
  FaUserCheck,
  FaUserTimes,
} from "react-icons/fa";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { Button } from "react-bootstrap";
import UserActivation from "./UserActivation";
import { toastOptions } from "../../utils/error";
import { ToastContainer, toast } from "react-toastify";

const column = [
  "S.No",
  "Profile Image",
  "Name",
  "E-Mail",
  "Number",
  "Verified",
  "Activate",
  "Available",
  "Action",
];
const User = () => {
  useTitle("Users");

  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(5);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showActivationModal, setShowActivationModal] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [userId, setuserId] = useState("");
  const navigate = useNavigate();

  const { isFetching, isError, data, error, endpointName, refetch } =
    useGetAllUsersQuery({
      page: currentPage,
      limit: resultPerPage,
    });
  const [toggleActivation, { isLoading, isSuccess, error: isActivitationError }] =
    useToggleActivationMutation();

  const [deleteUser, { isLoading: isDeleteLoading, isSuccess: isDeleteUserSuccess, error: isDeleteUserError }] = useDeleteUserMutation();

  useEffect(() => {
    if (isSuccess) {
      toast.success(`User ${isActive ? "Deactivated" : "Activated"} Successfully!`, toastOptions);
    }
  }, [isSuccess])

  const pageHandler = (p) => setCurrentPage(p);

  const handleDelete = (id) => {
    setuserId(id);
    setShowConfirmationModal(true);
  };

  const deleteHandler = async (e) => {
    e.preventDefault();
    await deleteUser(userId);
  };

  const handleActivation = ({ id, is_active }) => {
    setuserId(id);
    setIsActive(is_active);
    toggleActivation(id)
  };

  const handleOnHide = () => {
    setShowConfirmationModal(false)
  }
  return (
    <MotionDiv>
      {isError ? (
        <MessageBox variant="danger">{error?.data?.error?.message}</MessageBox>
      ) : (
        <CustomTable
          loading={isFetching || isLoading}
          column={column}
          rowNo={resultPerPage}
          rowProps={{ setResultPerPage }}
          paging={true}
          pageProps={{ numOfPages: data?.totalPages, curPage: currentPage }}
          pageHandler={pageHandler}
        >
          {data?.users &&
            data.users.map((user, i) => (
              <tr key={user.id} className="odd">
                <td className="text-center">
                  {(currentPage - 1) * resultPerPage + i + 1}
                </td>
                <td className=" text-center">
                  {user.image ? (
                    <img className="td-img" src={user.image} alt="img" />
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.phone}</td>
                <td className=" text-center">
                  {user.is_verified ? (
                    <FaCheck className="green" />
                  ) : (
                    <ImCross className="red" />
                  )}
                </td>
                <td className="text-center">
                  <Button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    onClick={() => handleActivation({
                      id: user.id,
                      is_active: user.is_active
                    })}
                  >
                    {user.is_active ? (
                      <FaCheckSquare className="green" />
                    ) : (
                      <MdCheckBoxOutlineBlank className="green" />
                    )}
                  </Button>
                </td>
                <td className=" text-center">
                  {user.available ? (
                    <FaCheck className="green" />
                  ) : (
                    <ImCross className="red" />
                  )}
                </td>
                <td className=" text-center">
                  <ViewButton
                    onClick={() => navigate(`/admin/users/view/${user.id}`)}
                  />
                  <DeleteButton onClick={() => handleDelete(user.id)} />
                </td>
              </tr>
            ))}
          <ConfirmationModal
            show={showConfirmationModal}
            onHide={handleOnHide}
            title="Delete User"
            body="Do you really want to delete this Appraiser ?"
            successMessage="User Deleted Successfully!"
            submitHandler={deleteHandler}
            reducerProps={{
              loading: isDeleteLoading,
              success: isDeleteUserSuccess,
              error: isDeleteUserError,
            }}
          ></ConfirmationModal>

          <UserActivation
            show={showActivationModal}
            onHide={() => setShowActivationModal(false)}
            id={userId}
            isActive={isActive}
          />
        </CustomTable>
      )}
      <ToastContainer />
    </MotionDiv>
  );
};

export default User;
